import React, { useMemo } from 'react';
import {
  TbChevronLeft,
  TbChevronRight,
  TbChevronsLeft,
  TbChevronsRight,
} from 'react-icons/tb';
import { wrap, btn, pageBtn, edgeBtn } from './style';
import { IPageOption } from 'types';

const MAX_PAGE_DIFF = 4;

interface Props {
  pageOption: IPageOption;
  totalPage?: number;
  handlePage: (option: IPageOption) => void;
}

function Pagination({ pageOption, handlePage, totalPage = 20 }: Props) {
  const { page, size } = pageOption;

  const pages = useMemo(() => {
    let start = page - 2;
    if (start + MAX_PAGE_DIFF > totalPage) start = totalPage - MAX_PAGE_DIFF;
    if (start < 1) start = 1;

    return new Array(totalPage > MAX_PAGE_DIFF ? 5 : totalPage)
      .fill('')
      .map((_, i) => i + start);
  }, [totalPage, page]);

  const setPage = (page: number) => {
    handlePage({
      size,
      page,
    });
  };

  return (
    <div css={wrap}>
      <button
        type="button"
        css={[btn, edgeBtn]}
        onClick={() => setPage(1)}
        aria-label="첫 페이지"
      >
        <TbChevronsLeft size={18} />
      </button>
      <button
        type="button"
        css={btn}
        onClick={() => setPage(page - 1)}
        disabled={page - 1 < 1}
        aria-label="이전 페이지"
      >
        <TbChevronLeft size={18} />
      </button>
      {pages.map((p, i) => (
        <button
          key={i}
          type="button"
          css={[btn, pageBtn(pageOption.page === p)]}
          onClick={() => setPage(p)}
          aria-current={pageOption.page === p ? 'page' : undefined}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        css={btn}
        onClick={() => setPage(page + 1)}
        disabled={page + 1 > totalPage}
        aria-label="다음 페이지"
      >
        <TbChevronRight size={18} />
      </button>
      <button
        type="button"
        css={[btn, edgeBtn]}
        onClick={() => setPage(totalPage)}
        aria-label="마지막 페이지"
      >
        <TbChevronsRight size={18} />
      </button>
    </div>
  );
}

export default Pagination;
